import { useIntl, FormattedMessage } from 'react-intl';
import { EuiToolTip } from '@elastic/eui';

import * as S from './CompressedCalculatePriceCard.styles';
import { PricePredictionResponse } from 'generated/graphql';
import { ReactNode } from 'react';
import { Icon } from 'icon/Icon';

interface CompressedCalculatePriceCardProps extends Omit<PricePredictionResponse, 'success'> {
  onClose: () => void;
}

export const CompressedCalculatePriceCard: (p: CompressedCalculatePriceCardProps) => JSX.Element = ({
  predictedPrice,
  vehicleRegistrationDateISO8601,
  lowerboundPredictedPrice,
  upperboundPredictedPrice,
  averageListingDurationInDays,
  mds,
  vehicleKM,
  onClose,
}): JSX.Element => {
  const intl = useIntl();

  return (
    <S.CompressedCalculatePriceCard>
      <S.Message>
        <FormattedMessage
          id="compressedCalculatePriceCard.message"
          values={{
            b: ((chunks: string) => <b>{chunks}</b>) as unknown as ReactNode,
          }}
        />
      </S.Message>

      <S.Item>
        <Icon iconName="Min" />
        <div>
          <S.ItemTitle>
            <FormattedMessage id="minimum" />
          </S.ItemTitle>
          <S.ItemValue className="value">{`${lowerboundPredictedPrice} €`}</S.ItemValue>
        </div>
      </S.Item>
      <S.Item>
        <Icon iconName="Suggested" />
        <div>
          <S.ItemTitle>
            <FormattedMessage id="suggested" />
          </S.ItemTitle>
          <S.ItemValue className="value">{`${predictedPrice} €`}</S.ItemValue>
        </div>
      </S.Item>
      <S.Item>
        <Icon iconName="Max" />
        <div>
          <S.ItemTitle>
            <FormattedMessage id="maximum" />:
          </S.ItemTitle>
          <S.ItemValue className="value">{`${upperboundPredictedPrice} €`}</S.ItemValue>
        </div>
      </S.Item>
      <S.Spacer />
      <S.Item>
        <Icon iconName="Clock" />
        <div>
          <S.ItemTitle>
            <FormattedMessage id="calculatePriceCard.durationInDaysShort" />
            <EuiToolTip
              position="top"
              content={
                <>
                  Vend.: giorni medi di vendita per questo tipo di veicolo
                  <br />
                  MDS: Market Days Supply, stima dei giorni per esaurire lo stock al ritmo attuale di vendita
                </>
              }
            >
              <span style={{ cursor: 'help', color: '#98A2B3', fontSize: '11px' }}>ⓘ</span>
            </EuiToolTip>
          </S.ItemTitle>
          <S.ItemValue className="value">{`${averageListingDurationInDays ?? '-'}/${
            mds != null ? Math.round(mds) : '-'
          } gg`}</S.ItemValue>
        </div>
      </S.Item>
      {vehicleKM && (
        <S.Item>
          <Icon iconName="Km" />
          <div>
            <S.ItemTitle>Km</S.ItemTitle>
            <S.ItemValue>{`${vehicleKM} km`}</S.ItemValue>
          </div>
        </S.Item>
      )}
      {vehicleRegistrationDateISO8601 && (
        <S.Item>
          <Icon iconName="Calendar" />
          <div>
            <S.ItemTitle>
              <FormattedMessage id="vehicle-registration-date" />
            </S.ItemTitle>
            <S.ItemValue>{vehicleRegistrationDateISO8601}</S.ItemValue>
          </div>
        </S.Item>
      )}
      <S.CloseButton onClick={onClose}>
        {intl.formatMessage({ id: 'compressedCalculatePriceCard.closeCard' })}
      </S.CloseButton>
    </S.CompressedCalculatePriceCard>
  );
};
